import { useCalibration } from '../../../context/calibrationContext';
import { usePostMessage } from '../../../context/messageContext';
import { CalibrationSelectionView } from '../../session/calibration/ClinicianCalibrationViews';

// C2 / C4 Calibration Selection: Screen and Camera cards. The ws messages are unchanged
// ('screen-calibration' puts the patient on P3, 'camera-calibration-selection' starts the camera
// flow). Next (Set Distance) needs the screen calibrated; the camera is optional (face detection
// falls back to the default focal length).
const CalibrationSelection = ({ setStep, setActiveTab }) => {
  const postMessage = usePostMessage();
  const {
    calibrationData: { screenCalibrated, cameraCalibrated, patientUsingResponsiveView },
  } = useCalibration();

  const selectCalibrationType = (selection) => {
    postMessage({ type: selection });
    return setStep(selection);
  };

  return (
    <CalibrationSelectionView
      screenCalibrated={Boolean(screenCalibrated)}
      cameraCalibrated={Boolean(cameraCalibrated)}
      responsiveNote={Boolean(patientUsingResponsiveView)}
      onCalibrateScreen={() => selectCalibrationType('screen-calibration')}
      onCalibrateCamera={() => selectCalibrationType('camera-calibration-selection')}
      onNext={() => setActiveTab('set-distance')}
    />
  );
};

export default CalibrationSelection;
